module.exports = __webpack_public_path__ + "images/speed-three-active.683292d6ab3df570dea60fe56b148def.png";